import React, { Component } from 'react'
import { PointsCash, CreditCard } from './PointsCash'
import { PointsOnly } from './PointsOnly'
import PropTypes from 'prop-types'
import BodyPlaceholder from './BodyPlaceholder'
import { CatalogCurrencyLabel } from 'Shared/CurrencyLabel'

class Body extends Component {
  componentDidMount () {
    if (this.props.onlyCash) {
      this.props.fetchCashOnlyConfig()
    } else {
      this.props.fetchPointsCashConfig()
    }
  }

  render () {
    const { payment, balance, totalPrice, onlyCash } = this.props
    const {
      isLoading,
      isAbilityInCampaing: pointsCashAvailable
    } = payment.pointsCashConfig
    if (isLoading) return <BodyPlaceholder />

    if (onlyCash) {
      return (
        <div className='row px-0 pb-2 space-m'>
          <div className='col-12 px-2 py-2 border-top border-color-ui-2'>
            <div className='row mx-1'>
              <CreditCard {...this.props} />
            </div>
          </div>
        </div>
      )
    }

    if (pointsCashAvailable) {
      if (payment.isDepreciated) {
        this.props.fetchPointsCashConfig()
      }

      return (
        <div className='row px-0 pb-1 space-m'>
          <div className='col-12 px-2 border-top border-color-ui-2'>
            <div className='row mx-1'>
              <div className='col-12 border-color-ui-3 pt-2'>
                <div className='row'>
                  <div className='col-12 px-0'>
                    <p className='txt-body-sm text-payment mt-1 mb-1'>
                      Selecione um meio de pagamento, você também pode utilizar
                      seu cartão de crédito.
                    </p>
                  </div>
                </div>
              </div>
              <PointsOnly {...this.props} />
              <PointsCash {...this.props} />
            </div>
          </div>
        </div>
      )
    }

    return (
      <div className='row px-0 pb-2 border-top border-color-ui-2'>
        <div className='col-12 px-2'>
          <div className='row mx-1'>
            <div className='col-12 border-color-ui-3 pt-2'>
              <div className='row'>
                <div className='col-12 px-0'>
                  <p className='txt-body-sm'>
                    Este resgate irá utilizar{' '}
                    <CatalogCurrencyLabel value={totalPrice.points} />
                  </p>
                  <p className='txt-body-sm'>
                    Você possui{' '}
                    <CatalogCurrencyLabel value={balance.pointsValue} />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

Body.propTypes = {
  payment: PropTypes.object,
  balance: PropTypes.object,
  totalPrice: PropTypes.object,
  isLoading: PropTypes.bool,
  isAbilityInCampaing: PropTypes.bool,
  onlyCash: PropTypes.bool,
  fetchPointsCashConfig: PropTypes.func,
  handleStepChange: PropTypes.func,
  orientation: PropTypes.string,
  fetchCashOnlyConfig: PropTypes.func
}

export default Body



// WEBPACK FOOTER //
// ./src/features/Checkout/Payment/Body/Body.js